export enum PortMasterEnum {
  //Domestic
  Anchorage = "Anchorage",
  Baltimore = "Baltimore",
  Beaumont = "Beaumont",
  Jacksonville = "Jacksonville",
  Brunswick = "Brunswick",
  Charleston = "Charleston",
  CorpusChristi = "CorpusChristi",
  Davisville = "Davisville",
  FortLauderdale = "FortLauderdale",
  Galveston = "Galveston",
  Gulfport = "Gulfport",
  Honolulu = "Honolulu",
  Marrero = "Marrero",
  Newark = "Newark",
  NewYork = "NewYork",
  Newport = "Newport",
  Norfolk = "Norfolk",
  Portland = "Portland",
  San = "San",
  Savannah = "Savannah",
  Tacoma = "Tacoma",
  //International
  Vancouver = "Vancouver",
  Victoria = "Victoria",
  Halifax = "Halifax",
  Altamira = "Altamira",
  Antwerp = "Antwerp",
  Arica = "Arica",
  Bremerhaven = "Bremerhaven",
  Brisbane = "Brisbane",
  Callao = "Callao",
  Cartagena = "Cartagena",
  Guangzhou = "Guangzhou",
  Esbjerg = "Esbjerg",
  Galle = "Galle",
  Gdansk = "Gdansk",
  Alexandroupolis = "Alexandroupolis",
  Thessaloniki = "Thessaloniki",
  Incheon = "Incheon",
  Kuwait = "Kuwait",
  Manta = "Manta",
  Manzanillo = "Manzanillo",
  Nagoya = "Nagoya",
  Oranjestad = "Oranjestad",
  Panama = "Panama",
  Paranagua = "Paranagua",
  Pohang = "Pohang",
  Puerto = "Puerto",
  Rio = "Rio",
  Santos = "Santos",
  Singapore = "Singapore",
  Southampton = "Southampton",
  Suape = "Suape",
  Veracruz = "Veracruz",
  Yokohama = "Yokohama",
  Freeport = "Freeport",
  Melbourne = "Melbourne",
  Fremantle = "Fremantle",
  Auckland = "Auckland",
  Darwin = "Darwin",
  Bowen = "Bowen",
  Abbotts_Point = "Abbotts_Point",
  Ulsan = "Ulsan",
  Papeete = "Papeete",
  //Specific port relief
  BALTIMORE_1 = "BALTIMORE_1",
  BALTIMORE_2 = "BALTIMORE_2",
  BALTIMORE_1ST = "BALTIMORE_1ST",
  BALTIMORE_2ND = "BALTIMORE_2ND",
  CHARLESTON_1 = "CHARLESTON_2",
  CHARLESTON_2 = "CHARLESTON_2",
  CHARLESTON_1ST = "CHARLESTON_1ST",
  CHARLESTON_2ND = "CHARLESTON_2ND",
  BRUNSWICK_1 = "BRUNSWICK_1",
  BRUNSWICK_2 = "BRUNSWICK_2",
  BRUNSWICK_1ST = "BRUNSWICK_1ST",
  BRUNSWICK_2ND = "BRUNSWICK_2ND",
  PDX = "PDX",
}

export const DisabledPorts = [
  PortMasterEnum.BALTIMORE_1,
  PortMasterEnum.BALTIMORE_2,
  PortMasterEnum.BALTIMORE_1ST,
  PortMasterEnum.BALTIMORE_2ND,
  PortMasterEnum.CHARLESTON_1,
  PortMasterEnum.CHARLESTON_2,
  PortMasterEnum.CHARLESTON_1ST,
  PortMasterEnum.CHARLESTON_2ND,
  PortMasterEnum.BRUNSWICK_1,
  PortMasterEnum.BRUNSWICK_2,
  PortMasterEnum.BRUNSWICK_1ST,
  PortMasterEnum.BRUNSWICK_2ND,
];

export const SelectablePortKeys = Object.keys(PortMasterEnum).filter(
  (port) => !DisabledPorts.includes(port as PortMasterEnum)
);

export const PortMasterLabel: { [key in PortMasterEnum]: string } = {
  [PortMasterEnum.Anchorage]: "Anchorage, AK",
  [PortMasterEnum.Baltimore]: "Baltimore, MD",
  [PortMasterEnum.Beaumont]: "Beaumont, TX",
  [PortMasterEnum.Jacksonville]: "Jacksonville, FL",
  [PortMasterEnum.Brunswick]: "Brunswick, GA",
  [PortMasterEnum.Charleston]: "Charleston, SC",
  [PortMasterEnum.CorpusChristi]: "Corpus Christi, TX",
  [PortMasterEnum.Davisville]: "Davisville, RI",
  [PortMasterEnum.FortLauderdale]: "Fort Lauderdale, FL",
  [PortMasterEnum.Galveston]: "Galveston, TX",
  [PortMasterEnum.Gulfport]: "Gulfport, MS",
  [PortMasterEnum.Honolulu]: "Honolulu, HI",
  [PortMasterEnum.Marrero]: "Marrero, LA",
  [PortMasterEnum.Newark]: "Newark, NJ",
  [PortMasterEnum.NewYork]: "New York, NY",
  [PortMasterEnum.Newport]: "Newport News, VA",
  [PortMasterEnum.Norfolk]: "Norfolk, VA",
  [PortMasterEnum.Portland]: "Portland, OR",
  [PortMasterEnum.San]: "San Juan, PR",
  [PortMasterEnum.Savannah]: "Savannah, GA",
  [PortMasterEnum.Tacoma]: "Tacoma, WA",
  [PortMasterEnum.Vancouver]: "Vancouver, WA",
  [PortMasterEnum.Victoria]: "Victoria, British Columbia",
  [PortMasterEnum.Halifax]: "Halifax, NS, Canada",
  [PortMasterEnum.Altamira]: "Altamira, Mexico",
  [PortMasterEnum.Antwerp]: "Antwerp, Belgium",
  [PortMasterEnum.Arica]: "Arica, Chile",
  [PortMasterEnum.Bremerhaven]: "Bremerhaven, Germany",
  [PortMasterEnum.Brisbane]: "Brisbane, Australia",
  [PortMasterEnum.Callao]: "Callao, Peru",
  [PortMasterEnum.Cartagena]: "Cartagena, Columbia",
  [PortMasterEnum.Guangzhou]: "Guangzhou, China",
  [PortMasterEnum.Esbjerg]: "Esbjerg, Denmark",
  [PortMasterEnum.Galle]: "Galle, Sirlanka",
  [PortMasterEnum.Gdansk]: "Gdansk, Poland",
  [PortMasterEnum.Alexandroupolis]: "Alexandroupolis, Greece",
  [PortMasterEnum.Thessaloniki]: "Thessaloniki, Greece",
  [PortMasterEnum.Incheon]: "Incheon, South Korea",
  [PortMasterEnum.Kuwait]: "Kuwait, Kuwait",
  [PortMasterEnum.Manta]: "Manta, Ecuador",
  [PortMasterEnum.Manzanillo]: "Manzanillo, Panama",
  [PortMasterEnum.Nagoya]: "Nagoya, Japan",
  [PortMasterEnum.Oranjestad]: "Oranjestad, Aruba",
  [PortMasterEnum.Panama]: "Panama City, Panama",
  [PortMasterEnum.Paranagua]: "Paranagua, Brazil",
  [PortMasterEnum.Pohang]: "Pohang, South Korea",
  [PortMasterEnum.Puerto]: "Puerto Angamos, Chile",
  [PortMasterEnum.Rio]: "Rio de Janeiro, Brazil",
  [PortMasterEnum.Santos]: "Santos, Brazil",
  [PortMasterEnum.Singapore]: "Singapore, Singapore",
  [PortMasterEnum.Southampton]: "Southampton, UK",
  [PortMasterEnum.Suape]: "Suape, Brazil",
  [PortMasterEnum.Veracruz]: "Veracruz, Mexico",
  [PortMasterEnum.Yokohama]: "Yokohama, Japan",
  [PortMasterEnum.Freeport]: "Freeport, Grand Bahamas",
  [PortMasterEnum.Melbourne]: "Melbourne, Australia",
  [PortMasterEnum.Fremantle]: "Fremantle, Australia",
  [PortMasterEnum.Auckland]: "Auckland, New Zealand",
  [PortMasterEnum.BALTIMORE_1]: "1st Baltimore",
  [PortMasterEnum.CHARLESTON_1]: "1st Charleston",
  [PortMasterEnum.CHARLESTON_2]: "2nd Charleston",
  [PortMasterEnum.BALTIMORE_2]: "2nd Baltimore",
  [PortMasterEnum.BALTIMORE_1]: "Baltimore 1, MD",
  [PortMasterEnum.BALTIMORE_2]: "Baltimore 2, MD",
  [PortMasterEnum.BALTIMORE_1ST]: "1st Baltimore, MD",
  [PortMasterEnum.BALTIMORE_2ND]: "2nd Baltimore, MD",
  [PortMasterEnum.CHARLESTON_1]: "Charleston 1, SC",
  [PortMasterEnum.CHARLESTON_2]: "Charleston 2, SC",
  [PortMasterEnum.CHARLESTON_1ST]: "1st Charleston, SC",
  [PortMasterEnum.CHARLESTON_2ND]: "2nd Charleston, SC",
  [PortMasterEnum.BRUNSWICK_1]: "Brunswick 1, GA",
  [PortMasterEnum.BRUNSWICK_2]: "Brunswick 2, GA",
  [PortMasterEnum.BRUNSWICK_1ST]: "1st Brunswick, GA",
  [PortMasterEnum.BRUNSWICK_2ND]: "2nd Brunswick, GA",
  [PortMasterEnum.PDX]: "PDX",
  [PortMasterEnum.Darwin]: "Darwin, Australia",
  [PortMasterEnum.Abbotts_Point]: "Abbotts Point, Australia",
  [PortMasterEnum.Bowen]: "Bowen, Australia",
  [PortMasterEnum.Ulsan]: "Ulsan, South Korea",
  [PortMasterEnum.Papeete]: "Papeete, Tahiti",
};

export enum ValidTimezone {
  GMT_MINUS_12 = "Etc/GMT+12",
  GMT_MINUS_11 = "Pacific/Midway",
  US_HAWAII = "US/Hawaii",
  US_ALASKA = "US/Alaska",
  US_PACIFIC = "US/Pacific",
  US_MOUNTAIN = "US/Mountain",
  US_ARIZONA = "US/Arizona",
  US_CENTRAL = "US/Central",
  US_EASTERN = "US/Eastern",
  US_ATLANTIC = "US/Puerto Rico",
  MEXICO_NORTHWEST = "Mexico/BajaNorte",
  MEXICO_PACIFIC = "Mexico/BajaSur",
  MEXICO_CENTRAL = "Mexico/General",
  // TODO: MEXICO_SOUTHEAST: new timezone for 2023, not yet in JodaTime(?)
  GMT_MINUS_5 = "Etc/GMT+5",
  GMT_MINUS_4 = "Etc/GMT+4",
  GMT_MINUS_3 = "Etc/GMT+3",
  GMT_MINUS_2 = "Etc/GMT+2",
  CANADA_NEWFOUNDLAND = "Canada/Newfoundland",
  CHILE_EASTER = "Chile/EasterIsland",
  CHILE_CONTINENTAL = "Chile/Continental",
  EU_WEST = "WET",
  EU_CENTRAL = "CET",
  EU_EAST = "EET",
  RUSSIA_KALININGRAD = "Europe/Kaliningrad",
  GMT_0 = "Etc/GMT",
  GMT_PLUS_1 = "Etc/GMT-1",
  GMT_PLUS_2 = "Etc/GMT-2",
  GMT_PLUS_3 = "Etc/GMT-3",
  EGYPT = "Egypt",
  IRAN = "Iran",
  GMT_PLUS_4 = "Etc/GMT-4",
  GMT_PLUS_5 = "Etc/GMT-5",
  INDIA = "Asia/Kolkata",
  GMT_PLUS_6 = "Etc/GMT-6",
  GMT_PLUS_7 = "Etc/GMT-7",
  GMT_PLUS_8 = "Etc/GMT-8",
  GMT_PLUS_9 = "Etc/GMT-9",
  GMT_PLUS_10 = "Etc/GMT-10",
  AUSTRALIA_WEST = "Australia/West",
  AUSTRALIA_EUCLA = "Australia/Eucla",
  AUSTRALIA_SOUTH = "Australia/South",
  AUSTRALIA_NORTH = "Australia/North",
  AUSTRALIA_QUEENSLAND = "Australia/Brisbane",
  AUSTRALIA_EASTERN = "Australia/Sydney",
  GMT_PLUS_11 = "Etc/GMT-11",
  GMT_PLUS_12 = "Etc/GMT-12",
  NEW_ZEALAND = "NZ",
  CHATHAM = "NZ-CHAT",
  GMT_PLUS_13 = "Etc/GMT-13",
  GMT_PLUS_14 = "Etc/GMT-14",
}

export const ValidTimezoneLabel: { [key in ValidTimezone]: string } = {
  [ValidTimezone.GMT_MINUS_12]: "GMT-12",
  [ValidTimezone.GMT_MINUS_11]: "Midway Islands Time",
  [ValidTimezone.US_HAWAII]: "US/Hawaii Time",
  [ValidTimezone.US_ALASKA]: "US/Alaska Time",
  [ValidTimezone.US_PACIFIC]: "US/Pacific Time",
  [ValidTimezone.US_MOUNTAIN]: "US/Mountain Time",
  [ValidTimezone.US_ARIZONA]: "US/Arizona Time",
  [ValidTimezone.US_CENTRAL]: "US/Central Time",
  [ValidTimezone.US_EASTERN]: "US/Eastern Time",
  [ValidTimezone.US_ATLANTIC]: "US/Puerto Rico and US Virgin Islands Time",
  [ValidTimezone.CANADA_NEWFOUNDLAND]: "Canada/Newfoundland Time",
  [ValidTimezone.MEXICO_NORTHWEST]: "Mexico/Pacific Time",
  [ValidTimezone.MEXICO_PACIFIC]: "Mexico/Mountain Time",
  [ValidTimezone.MEXICO_CENTRAL]: "Mexico/Central Time",
  // TODO: MEXICO_SOUTHEAST: new timezone for 2023, not yet in JodaTime(?)
  [ValidTimezone.GMT_MINUS_5]: "South America/GMT-5",
  [ValidTimezone.GMT_MINUS_4]: "South America/GMT-4",
  [ValidTimezone.GMT_MINUS_3]: "South America/GMT-3",
  [ValidTimezone.GMT_MINUS_2]: "South America/GMT-2",
  [ValidTimezone.CHILE_EASTER]: "Chile/Easter Island Time",
  [ValidTimezone.CHILE_CONTINENTAL]: "Chile/Continental Chile Time",
  [ValidTimezone.EU_WEST]: "Europe/Western European Time",
  [ValidTimezone.EU_CENTRAL]: "Europe/Central European Time",
  [ValidTimezone.EU_EAST]: "Europe/Eastern European Time",
  [ValidTimezone.RUSSIA_KALININGRAD]: "Europe/Kaliningrad Time",
  [ValidTimezone.GMT_0]: "Africa/GMT-0",
  [ValidTimezone.GMT_PLUS_1]: "Africa/GMT+1",
  [ValidTimezone.GMT_PLUS_2]: "Africa/GMT+2",
  [ValidTimezone.GMT_PLUS_3]: "Africa/GMT+3",
  [ValidTimezone.EGYPT]: "Africa/Egypt Time",
  [ValidTimezone.IRAN]: "Asia/Iran Time",
  [ValidTimezone.GMT_PLUS_4]: "Asia/GMT+4",
  [ValidTimezone.GMT_PLUS_5]: "Asia/GMT+5",
  [ValidTimezone.INDIA]: "Asia/India Time",
  [ValidTimezone.GMT_PLUS_6]: "Asia/GMT+6",
  [ValidTimezone.GMT_PLUS_7]: "Asia/GMT+7",
  [ValidTimezone.GMT_PLUS_8]: "Asia/GMT+8",
  [ValidTimezone.GMT_PLUS_9]: "Asia/GMT+9",
  [ValidTimezone.GMT_PLUS_10]: "Asia/GMT+10",
  [ValidTimezone.AUSTRALIA_WEST]: "Australia/Western Time",
  [ValidTimezone.AUSTRALIA_EUCLA]: "Australia/Central Western Time",
  [ValidTimezone.AUSTRALIA_SOUTH]: "Australia/South Australia",
  [ValidTimezone.AUSTRALIA_NORTH]: "Australia/Norhtern Territory",
  [ValidTimezone.AUSTRALIA_QUEENSLAND]: "Australia/Queensland",
  [ValidTimezone.AUSTRALIA_EASTERN]: "Australia/New South Wales",
  [ValidTimezone.GMT_PLUS_11]: "Pacific/GMT+11",
  [ValidTimezone.GMT_PLUS_12]: "Pacific/GMT+12",
  [ValidTimezone.NEW_ZEALAND]: "New Zealand Time",
  [ValidTimezone.CHATHAM]: "New Zealand Chatham Time",
  [ValidTimezone.GMT_PLUS_13]: "Pacific/GMT+13",
  [ValidTimezone.GMT_PLUS_14]: "Pacific/GMT+14",
};
